import { InputNumber } from 'antd'
import styled from 'styled-components'

export const StyledInput = styled(InputNumber)`
  width: 60px;
`
